import React from 'react';
import { Menu, MenuButton, MenuList, MenuItem, Button, Text, Flex, Box } from '@chakra-ui/react';
import { DotsThreeVertical } from 'phosphor-react';

interface MenuItemType {
  name: string;
  path: string;
  icon: React.ReactNode;
  bgColor: string;
}

interface HeaderMenuDropdownProps {
  items: MenuItemType[];
  currentPath: string;
  // eslint-disable-next-line no-unused-vars
  onNavigate: (navPath: string) => void;
}

export const HeaderMenuDropdown: React.FC<HeaderMenuDropdownProps> = ({
  items,
  currentPath,
  onNavigate,
}) => {
  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="ghost"
        size="sm"
        colorScheme="gray"
        color="#475569"
        minW="auto"
        px={2}
        borderRadius="full"
        aria-label="Mais telas do módulo"
        _hover={{ bg: '#F1F5F9', color: '#0F172A' }}
        _active={{ bg: '#E2E8F0' }}
      >
        <DotsThreeVertical size={24} weight="bold" />
      </MenuButton>
      <MenuList
        bg="white"
        minW="280px"
        maxH="400px"
        overflowY="auto"
        boxShadow="0px 4px 6px rgba(0, 0, 0, 0.1)"
        zIndex={60}
      >
        {items.map(item => {
          const isActive = item.path === currentPath;
          return (
            <MenuItem
              key={item.path}
              onClick={() => onNavigate(item.path)}
              bg={isActive ? 'rgba(25, 106, 187, 0.1)' : 'transparent'}
              _hover={{
                bg: isActive ? 'rgba(25, 106, 187, 0.15)' : 'rgba(25, 106, 187, 0.05)',
              }}
              px={3}
              py={2.5}
            >
              <Flex align="center" gap={2.5} w="full">
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="full"
                  p={1.5}
                  flexShrink={0}
                  style={{ backgroundColor: item.bgColor }}
                >
                  {item.icon}
                </Box>
                <Text
                  fontSize="13px"
                  fontWeight={isActive ? 'bold' : 'medium'}
                  color="gray.700"
                  whiteSpace="normal"
                >
                  {item.name}
                </Text>
              </Flex>
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};
